import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SefariaHalachaService } from './sefaria-halacha-service.service';
import { MenuService } from './menu.service';


@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private router: Router,
    private sefariaService: SefariaHalachaService,
    private menuService: MenuService
  ) { }

  navigateToRandomSection(): void {
    this.sefariaService.jumpToRandomSection();
    this.router.navigate(['/section']);
    this.menuService.closeMenu();
  }
  navigateToChapters() {
    this.router.navigate(['/chapters']);
    this.menuService.closeMenu();
  }

  navigateToExams() {
    this.router.navigate(['/exams']);
    this.menuService.closeMenu();
  }

  navigateToHome() {
    this.router.navigate(['/']);
    this.menuService.closeMenu();
  }

  // navigateToChapter(book: string, chapter: number, section: number): void {
  //   this.sefariaService.currentSection.set({
  //     book,
  //     chapter,
  //     section
  //   });
  //   this.router.navigate(['/section']);
  // }
}